import { useAddComment, useEditComment } from '@/hooks/api/comments';
import {
  Button,
  DialogActions,
  DialogContent,
  Rating,
  TextField,
  Box,
  Typography,
} from '@mui/material';
import { enqueueSnackbar } from 'notistack';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';

const CommentDialog = ({
  closeModal,
  type = null,
  parent = null,
  id = '',
  handleRefetchData = null,
  commentId = null,
  content = '',
  lastRate = 0,
  isUpdate = false,
  isReply = false,
}) => {
  const [rate, setRate] = useState(0);
  const { mutate, isPending, isSuccess } = useAddComment();
  const {
    mutate: mutateEdit,
    isPending: isPendingEdit,
    isSuccess: isSuccessEdit,
  } = useEditComment();
  const {
    register,
    handleSubmit,
    setValue,
    getValues,
    formState: { errors },
  } = useForm();

  const onSubmit = data => {
    isUpdate
      ? mutateEdit(
          {
            commentId,
            ...(rate > 0 && { rate }),
            ...data,
          },
          {
            onSuccess: () => {
              closeModal();
              enqueueSnackbar({
                variant: 'success',
                message: 'ویرایش با موفقیت انجام شد',
              });
            },
          },
        )
      : mutate(
          {
            type,
            ...(parent && { parent }),
            ...(rate > 0 && { rate }),
            ...data,
            post: id,
          },
          {
            onSuccess: () => {
              closeModal();
              enqueueSnackbar({
                variant: 'success',
                message: 'نظر شما با موفقیت ثبت شد',
              });
              handleRefetchData && handleRefetchData();
            },
          },
        );
  };

  useEffect(() => {
    if (commentId) {
      setValue('content', content);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [commentId]);

  useEffect(() => {
    if (lastRate) {
      setRate(lastRate);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lastRate]);

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <DialogContent>
          {(type === 'course' || type === 'blog') && !isReply && (
            <Box sx={{ textAlign: 'center', mb: 2 }}>
              <Typography component="legend">
                {`امتیاز مورد نظر خود را در مورد این ${type == 'course' ? 'دوره' : 'مقاله'} انتخاب نمایید`}
              </Typography>
              <Rating
                size="large"
                name="rating-course"
                value={rate}
                onChange={(event, newValue) => {
                  setRate(newValue);
                }}
              />
            </Box>
          )}
          <TextField
            fullWidth
            rows={5}
            multiline
            label="متن نظر"
            inputProps={{ maxLength: 600 }}
            {...register('content', {
              required:
                type === 'course'
                  ? 'متن نظر الزامی است'
                  : 'متن سوال الزامی است',
              maxLength: {
                value: 600,
                message: 'حداکثر طول متن 600 کاراکتر می باشد',
              },
              minLength: {
                value: 5,
                message: 'حداقل 5 کاراکتر باید درج گردد',
              },
            })}
            error={!!errors.content}
            helperText={errors.content?.message}
            disabled={isPending}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={closeModal}>انصراف</Button>
          <Button
            type="submit"
            variant="contained"
            disabled={isPending || isPendingEdit}
            sx={{ px: 5 }}>
            {isUpdate ? 'ویرایش' : 'ثبت '}
          </Button>
        </DialogActions>
      </form>
    </>
  );
};

export default CommentDialog;
